import { Routes } from '@angular/router';
import { AuthGuard } from '@auth0/auth0-angular';
import { NotFoundComponent } from './frontend/404/not-found.component';
import { PageMetadata } from './util/router/page-metadata.interfaces';

export const routes: Routes = [
  {
    title: $localize`:page title for '/404' route:404 Page Not Found`,
    path: '404',
    component: NotFoundComponent,
    data: {
      metadata: {
        keywords: [] as string[],
        description: $localize`:description for '/404' route:Oops! The page you are looking for on Skillz.be was not found. Go back to the homepage or contact us.`,
      } as PageMetadata,
    },
  },
  {
    path: 'portal',
    canActivate: [AuthGuard],
    loadChildren: () => import('./backoffice/backoffice.routes'),
  },
  {
    path: '',
    loadChildren: () => import('./frontend/frontend.routes'),
  },
  {
    path: 'be',
    redirectTo: '/',
    pathMatch: 'prefix',
  },
  {
    path: '**',
    redirectTo: '404',
  },
];
